import classNames from 'classnames';

import Skeleton from '../Skeleton/Skeleton';
import css from './SkeletonText.css';

interface SkeletonTextProps {
  lineCount: number;
  className?: string;
}

const SkeletonText = ({ className, lineCount }: SkeletonTextProps) => {
  return (
    <div className={classNames(css.root, className)}>
      {Array.from({ length: lineCount }, (_: unknown, index: number) => (
        <Skeleton key={index} />
      ))}
    </div>
  );
};

export default SkeletonText;
